// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';

import { KLRound3PathAssetByTryIndex } from '../constants/assets';
import KLOrientatioStepContainer from '../containers/KLOrientationStepContainer';
import { KLCollectibleIds, KLRound3CollectibleIds } from '../types/collectible';

const translationRatioMap = {
  [KLCollectibleIds.MARK]: [
    { x: 75, y: 30 },
    { x: 75, y: 35 },
    { x: 15, y: 25 },
  ],
  [KLCollectibleIds.TAG]: [
    { x: 3, y: 47 },
    { x: 3, y: 38.5 },
    { x: 75, y: 41 },
  ],
  [KLCollectibleIds.KNIFE]: [
    { x: 56, y: 64 },
    { x: 48, y: 60 },
    { x: 21, y: 60 },
  ],
};

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 90%;
  overflow: hidden;
`;

const StyledKLOrientatioStepContainer = styled(KLOrientatioStepContainer)`
  position: absolute;

  ${({ $x, $y }) => {
    if ($x || $y) {
      return css`
        left: ${$x}%;
        top: ${$y}%;
      `;
    }
  }}
`;

const PathIcon = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;

  transform: translate(-50%, -50%);
  z-index: -1;
`;

type KLOrientationStepListProps = {
  paginationIndex?: number;
};

const KLOrientationStepList = ({ paginationIndex = 0 }: KLOrientationStepListProps) => {
  const pathAssetPath = useMemo(() => KLRound3PathAssetByTryIndex[paginationIndex], [paginationIndex]);

  const StepList = useCallback(() => {
    return KLRound3CollectibleIds.map((collectibleId) => (
      <StyledKLOrientatioStepContainer
        key={`orientation-step-${collectibleId}`}
        stepId={collectibleId}
        paginationIndex={paginationIndex}
        $x={translationRatioMap[collectibleId][paginationIndex].x}
        $y={translationRatioMap[collectibleId][paginationIndex].y}
      />
    ));
  }, [paginationIndex]);

  return (
    <Wrapper>
      <StepList />
      <PathIcon src={pathAssetPath} alt="Chemin" />
    </Wrapper>
  );
};

export default KLOrientationStepList;
